import React from 'react'
import SurvellianceTable from '../components/Survelliance audit/servelliance audit page/SurvellianceTable'

const SurvellianceMainpage = () => {
  return (
    <div>
        <SurvellianceTable/>
    </div>
  )
}

export default SurvellianceMainpage
